import { storeGet } from 'mailup-react-helpers'

import { beAccountSettingsApiSendContactRequest } from 'Api/beAccountSettingsApi'
import { ACCOUNT_STORE_KEY } from 'Constants/index'

export async function sendContactRequest(email, type) {
  const idConsole = storeGet(ACCOUNT_STORE_KEY).Id
  let title = ''
  let description = ''
  if (type === 'brandShield') {
    title = `Richiesta da piattaforma ${idConsole} - Canale SMTP+  Brand Shield`
    description = email
  }

  await beAccountSettingsApiSendContactRequest({
    Title: title,
    Description: description
  })
}
